function focusDirective() {
    'ngInject';

    const FOCUS_CLASS = 'bb-focused';

    return {
        restrict: 'A',
        require: 'ngModel',
        link(scope, element, attrs, ctrl) {
            ctrl.$focused = false;
            return element.bind('focus', (evt) => {
                element.addClass(FOCUS_CLASS);
                return scope.$apply(() => ctrl.$focused = true);
            }).bind('blur', (evt) => {
                element.removeClass(FOCUS_CLASS);
                return scope.$apply(() => ctrl.$focused = false);
            });
        }
    };
}

// Directive for testing if a input is focused
// Provided by http://www.ng-newsletter.com/posts/validations.html
angular
    .module('BB.inputs')
    .directive('bbFocus', focusDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-inputs/focus/focus.directive.js